import App from './modules/App'
import FAQManager from "./components/FAQManager"
import Menu from "./components/Menu"
import Popup from "./components/Popup"
import SwiperManager from "./components/SwiperManager"
import Dropdown from "./components/Dropdown"
import ToggleViewManager from "./components/ToggleViewManager"
import InputNumberManager from "./components/InputNumberManager"
import ToggleSubMenuManager from "./components/ToggleSubMenuManager"
import FilterManager from './components/FilterManager'
import CartManager from './components/CartManager'
import Link from './components/Links'
import CheckoutV2 from './components/checkout/CheckoutV2'
import AddressFillFormManager from './components/checkout/AddressFillFormManager'
import CountryManager from './components/checkout/CountryManager'
import CountryManagerSingle from './components/checkout/CountryManagerSingle'
import PanelManager from './components/PanelManager'
import PopupMessage from './components/PopupMessage'

document.addEventListener('DOMContentLoaded', () => {
    new App()

    let root = {}
    root.menu = new Menu(root, [])
    root.menu.run()
    root.popup = new Popup(root, [])
    root.popup.run()
    root.swiperManager = new SwiperManager(root, [])
    root.swiperManager.run()
    root.fAQManager = new FAQManager(root, [])
    root.fAQManager.run()
    root.dropdown = new Dropdown(root, [])
    root.dropdown.run()
    root.toggleViewManager = new ToggleViewManager(root, [])
    root.toggleViewManager.run()
    root.inputNumberManager = new InputNumberManager(root, [])
    root.inputNumberManager.run()
    root.toggleSubMenuManager = new ToggleSubMenuManager(root, [])
    root.toggleSubMenuManager.run()
    root.filterManager = new FilterManager(root, [])
    root.filterManager.run()
    root.cartManager = new CartManager(root, [])
    root.cartManager.run()
    root.link = new Link(root, [])
    root.link.run()
    root.checkoutV2 = new CheckoutV2(root, [])
    root.checkoutV2.run()
    root.addressFillFormManager = new AddressFillFormManager(root, [])
    root.addressFillFormManager.run()
    root.countryManager = new CountryManager(root, [])
    root.countryManager.run()
    root.countryManagerSingle = new CountryManagerSingle(root, [])
    root.countryManagerSingle.run()
    root.panelManager = new PanelManager(root, [])
    root.panelManager.run()
    root.popupMessage = new PopupMessage(root, [])
    root.popupMessage.run()
}, false)
